




























































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { LookupItem } from '@/api/generated'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import VueMultiselect from 'vue-multiselect'
import { Inject, Prop } from 'vue-property-decorator'
import { OfferSettingsViewModel } from '@/business/offers/models/offer-settings-view-model'
import RespondecoEditor from '@/shared/components/respondeco-editor.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import UnifyTextarea from '@/shared/components/unify/unify-textarea.vue'
import RespondecoImage from '@/shared/components/respondeco-image.vue'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'
import RespondecoResourceChooser from '@/shared/components/respondeco-resource-chooser.vue'
import { FormGroup } from '@/shared/forms/form-group'
import { OfferForm } from '@/business/offers/models/offer-form'
import UnifyFormToggle from '@/shared/components/unify/unify-form-toggle.vue'
import MultiselectClear from '@/shared/components/multiselect-clear.vue'
import { Injector } from '@/config/dependency-injection'
import { AuthenticationService } from '@/authentication/authentication-service'
import OfferSettingsEvents from '@/business/offers/components/offer-settings-events.vue'

@Component({
  components: {
    OfferSettingsDate: OfferSettingsEvents,
    MultiselectClear,
    UnifyFormToggle,
    RespondecoResourceChooser,
    RespondecoIcon,
    RespondecoImage,
    UnifyTextarea,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    RespondecoEditor,
    VueMultiselect,
    RespondecoValidationFeedback,
  },
})
export default class OfferSettingsBasic extends Vue {
  @Prop({
    type: Object,
  })
  public readonly viewModel!: OfferSettingsViewModel

  @Inject()
  public readonly form!: FormGroup<OfferForm>

  get isNew() {
    return this.offer.id === undefined
  }

  get lookupCategories() {
    return this.viewModel.lookup.categories.map(item => item.value)
  }

  get lookupOfferTypes() {
    return this.viewModel.lookup.offerTypes.map(item => item.value)
  }

  get lookupOrganisationTypes() {
    return this.viewModel.lookup.organisationTypes.map(item => item.value)
  }

  get lookupSectors() {
    return this.viewModel.lookup.sectors.map(item => item.value)
  }

  get offer() {
    return this.viewModel.offer
  }

  get project() {
    return this.authenticationService.authenticatedUser().organisation.project
  }

  private authenticationService = Injector.get(AuthenticationService)

  public customAudienceLabel(option: string) {
    return this.$t('lookup.organisation_type.' + option)
  }

  public customCategoryLabel(option: string) {
    return this.$t('lookup.category.' + option)
  }

  public customOrganisationLabel(option: LookupItem) {
    return option.value
  }

  public customSectorLabel(option: string) {
    return this.$t('lookup.sector.' + option)
  }

  public customTypeLabel(option: string) {
    return this.$t('lookup.offer_type.' + option)
  }

  public resetSector(): void {
    this.form.value.sector = undefined
  }
}
